import AttachmentsUploadController from "../../../javascript/controllers/attachments_upload_controller"

// Docs::AttachmentsRegionComponent — MC-1092.
//
// The doc reading canvas reuses the shared upload controller unchanged: the
// "Attach file" picker and drag-and-drop onto this section, POSTing each file
// to `endpointValue`. It adds nothing of its own — paste is deliberately not
// wired on a doc, where an operator's paste belongs in the editor's markdown
// textarea, and the drop surface is this section (not a drawer body), which
// is the shared controller's default.
export default class extends AttachmentsUploadController {}
